<template>
  <div>

  </div>
</template>

<script>
  export default {
    name: "Order",
    created() {
      const pack = this.serviceInfo.package;
      this.$axios(this.getUrl(`${pack}/order?ordering=-id`)).then(res => {
        if(res.data.data.length === 0) {
          this.$router.replace(`${pack}/order_list_all`);
        } else {
          this.$router.replace(`${pack}/order_detail?id=${res.data.data[0].id}`);
        }
      });
    },
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style lang="stylus" scoped>

</style>
